/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    CodeAndLabelWithIndent,
    CodeAndLabelWithIndentFromJSON,
    CodeAndLabelWithIndentFromJSONTyped,
    CodeAndLabelWithIndentToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface TicketTimeLimitOverrideListConfig
 */
export interface TicketTimeLimitOverrideListConfig {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly channels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly relevances?: Array<number> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly cabinClasses?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly journeyTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly agencyGroups?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabelWithIndent>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly regions?: Array<CodeAndLabelWithIndent> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof TicketTimeLimitOverrideListConfig
     */
    readonly dateTimeZones?: Array<CodeAndLabel> | null;
}

export function TicketTimeLimitOverrideListConfigFromJSON(json: any): TicketTimeLimitOverrideListConfig {
    return TicketTimeLimitOverrideListConfigFromJSONTyped(json, false);
}

export function TicketTimeLimitOverrideListConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketTimeLimitOverrideListConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'channels': !exists(json, 'channels') ? undefined : (json['channels'] === null ? null : (json['channels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevances': !exists(json, 'relevances') ? undefined : json['relevances'],
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CodeAndLabelFromJSON)),
        'journeyTypes': !exists(json, 'journeyTypes') ? undefined : (json['journeyTypes'] === null ? null : (json['journeyTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(CodeAndLabelWithIndentFromJSON)),
        'dateTimeZones': !exists(json, 'dateTimeZones') ? undefined : (json['dateTimeZones'] === null ? null : (json['dateTimeZones'] as Array<any>).map(CodeAndLabelFromJSON)),
    };
}

export function TicketTimeLimitOverrideListConfigToJSON(value?: TicketTimeLimitOverrideListConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


